<svelte:head>
  <title>Requests| A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title">Your requests</div>
<div class="subtitle">Manage the requests you have made for business offers.</div>

{#if allItems != undefined}
  <div class="tabs">
    <ul>
      <li class:is-active={tab == "active"}>
        <a on:click={() => (tab = "active")}>Active</a>
      </li>
      <li class:is-active={tab == "completed"}>
        <a on:click={() => (tab = "completed")}>History</a>
      </li>
    </ul>
  </div>

  {#if items.length > 0}
    <table class="table is-fullwidth is-hoverable">
      <thead />
      <tbody>
        {#each items as item}
          <tr>
            {#if item.offer}
              <td>
                <div
                  class="is-pulled-left"
                  style="width=120px; margin-right:20px;"
                >
                  <a
                    href={$url("../../offer/" + item.offer.id)}
                    style="display:inline-block;width:120px;"
                  >
                    {#if item.offer.data.images?.[0]}
                      <img
                        alt="Offer"
                        src={item.offer.data.images[0]}
                        style="max-height:120px;max-width:120px;"
                      />
                    {:else}
                      <img
                        alt="Generic"
                        src="/assets/img/box.png"
                        style="height:120px;width:120px; background-color:#eee"
                      />
                    {/if}
                  </a>
                </div>
                <div class="-block">
                  <a href={$url("../../offer/" + item.offer.id)}>
                    {item.offer.data.name}
                  </a>
                </div>
                <div class="-block">{item.offer.data.description}</div>
              </td>
              <td>
                <span class="tag is-success is-light">
                  {getStatus(item.request)}
                </span>
              </td>
              <td />
            {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  {:else if tab === "active"}
    <article class="message is-success">
      <div class="message-body">
        Requests you make for offers will appear here.
      </div>
    </article>
  {:else}
    <article class="message is-success">
      <div class="message-body">Completed requests will appear here.</div>
    </article>
  {/if}
{/if}

<script lang="ts">
  import _ from "lodash";
  import { appState } from "../../../lib/appState";
  import getStatus from "../../../utils/getStatus";
  import { url } from "@sveltech/routify";

  let requests :Request_v2_Doc[];
  let offersById :any;

  let tab = "active";

  let allItems :any[] | undefined;

  let items :any[] = [];

  $: if (allItems) {
    if (tab === "active") {
      items = _(allItems)
        .filter((item: any) => item.request.data.status !== 'completed')
        .orderBy((item: any) => item.request.data.created, "desc")
        .value();
    } else if (tab === "completed") {
      items = _(allItems)
        .filter((item: any) => item.request.data.status === 'completed')
        .orderBy((item: any) => item.request.data.created, "desc")
        .value();
    }
  }

  $: allItems =
    requests && offersById
      ? _.map(requests, (request :Request_v2_Doc) => ({
          request,
          offer: offersById[request.data.offer],
        }))
      : undefined;

  let firebase = window.firebase;

  getRequests();

  async function getOffersForRequests(requestIds : RequestId[]) {

    const offers = [];

    // Have to batch for firestore 'in' query limit of 10
    for(let index = 0; index < requestIds.length; index = index + 10)
    {
      const requestIdsBatch = requestIds.slice(index, Math.min(index + 10, requestIds.length));

      const active = await firebase
        .firestore()
        .collection("published_offers_v1")
        .where(firebase.firestore.FieldPath.documentId(), "in", requestIdsBatch)
        .get()
        .then(snap => {
          return snap.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }));
        });

        offers.push(...active);

        const archived = await firebase
          .firestore()
          .collection("published_offers_archive_v1")
          .where(firebase.firestore.FieldPath.documentId(), "in", requestIdsBatch)
          .get()
          .then(snap => {
            return snap.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }));
          });

          offers.push(...archived);
      }
      
      offersById = _.keyBy(offers, "id");
  }



  async function getRequests() {
    firebase
      .firestore()
      .collection("requests_v2")
      .where("charity.id", "==", $appState.user!.charity)
      .onSnapshot((snap) => {
        requests = snap.docs.map((doc) => ({ id: doc.id, data: doc.data() as Request_v2 }));
        getOffersForRequests(_.map(requests, "data.offer"));
      });
  }
</script>
